const GLOBAL_LIBRARY_MODE_ROLES = new Set(['SUPERADMIN', 'SUPER_ADMIN', 'GLOBAL_OPERATOR'])

const normalizeRoleToken = (value: string | null | undefined) =>
  String(value ?? '')
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_')

export const resolveOperationsLibraryRoleName = (
  currentUserRoleName?: string | null,
  roleDetails?: {code?: string | null; roleName?: string | null; name?: string | null} | null
) =>
  normalizeRoleToken(
    currentUserRoleName ??
      roleDetails?.code ??
      roleDetails?.roleName ??
      roleDetails?.name ??
      ''
  )

export const canSelectOperationsLibraryMode = (normalizedRoleName: string) =>
  GLOBAL_LIBRARY_MODE_ROLES.has(normalizedRoleName)

export const canSelectOperationsLibraryModeForUser = (
  normalizedRoleName: string,
  currentUser?: {
    companyGroupAdminId?: number | null
    companyAdminId?: number | null
    vessel?: {id?: number | null} | null
  } | null
) => {
  if (normalizedRoleName === 'GLOBAL_OPERATOR') {
    return !currentUser?.companyGroupAdminId && !currentUser?.companyAdminId && !currentUser?.vessel?.id
  }
  return canSelectOperationsLibraryMode(normalizedRoleName)
}

export const resolveOperationsLibraryMode = (
  canSelectLibraryMode: boolean,
  defaultMode: 'master' | 'company'
) => (canSelectLibraryMode ? defaultMode : 'company')

export const coerceOperationsLibraryMode = (
  currentMode: 'master' | 'company',
  canSelectLibraryMode: boolean
) => (canSelectLibraryMode ? currentMode : 'company')

export const shouldShowOperationsLibraryModeToggle = (
  featureEnabled: boolean,
  canSelectLibraryMode: boolean
) => featureEnabled && canSelectLibraryMode

export const resolveAuthenticatedCompanyGroupAdminId = (
  currentUser?: {companyGroupAdminId?: number | null; companyGroupAdmin?: {id?: number | null} | null} | null
) => currentUser?.companyGroupAdminId ?? currentUser?.companyGroupAdmin?.id ?? undefined
